import {
  ChatAction,
  FETCH_MESSAGES_FAILURE,
  FETCH_MESSAGES_SUCCESS,
  MessageState,
  PERSIST_PURGE,
  RECEIVE_MESSAGE,
  SWITCH_ROOM,
} from '@/types'

const initialState: MessageState = {
  rooms: {},
  loading: false,
  error: null,
}

const messagesReducer = (
  state = initialState,
  action: ChatAction
): MessageState => {
  switch (action.type) {
    case SWITCH_ROOM:
      return {
        ...state,
        loading: true,
        error: null,
      }

    case RECEIVE_MESSAGE:
      const { roomId, message } = action.payload
      return {
        ...state,
        rooms: {
          ...state.rooms,
          [roomId]: [message, ...(state.rooms[roomId] || [])],
        },
      }

    case FETCH_MESSAGES_SUCCESS:
      const { roomId: fetchRoomId, messages } = action.payload
      return {
        ...state,
        rooms: {
          ...state.rooms,
          [fetchRoomId]: messages,
        },
        loading: false,
        error: null,
      }

    case FETCH_MESSAGES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    case PERSIST_PURGE:
      return initialState

    default:
      return state
  }
}

export default messagesReducer
